import {ChangeDetectionStrategy, Component, Inject, Injectable} from '@angular/core';

import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {TranslateModule} from "@ngx-translate/core";
import {AksjeeierbokId} from "../../../../../felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef} from "@angular/material/dialog";
import {MatSlideToggle} from "@angular/material/slide-toggle";
import {FormsModule} from "@angular/forms";
import {MatToolbar} from "@angular/material/toolbar";
import {MatIcon} from "@angular/material/icon";
import {MatAnchor, MatButton, MatIconButton} from "@angular/material/button";
import {Appkonfigurasjon} from "felles-ng2/tjenester/Appkonfigurasjon";


const debug = initDebugger('AksjeeierbokEksportDialogKomponent');

@Component({
    selector: 'aksjeeierbok-eksport-dialog',
    templateUrl: './aksjeeierbok-eksport-dialog.html',
    styleUrls: ['./aksjeeierbok-eksport-dialog.scss'],
    imports: [
        TranslateModule,
        MatSlideToggle,
        FormsModule,
        MatDialogContent,
        MatToolbar,
        MatIcon,
        MatDialogActions,
        MatIconButton,
        MatDialogClose,
        MatAnchor,
        MatButton
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AksjeeierbokEksportDialogKomponent {

    static vis(id: AksjeeierbokId, dialog: MatDialog): MatDialogRef<AksjeeierbokEksportDialogKomponent, void> {
        return dialog.open(AksjeeierbokEksportDialogKomponent, {data: {aksjeeierbokId: id} as EksportDialogParametre, disableClose: false});
    }


    constructor(private avhengigheter: AksjeeierbokEksportDialogKomponentAvhengigheter, @Inject(MAT_DIALOG_DATA) parametre: EksportDialogParametre) {
        this.aksjeeierbokId = parametre.aksjeeierbokId;
    }

  aksjeeierbokId!:AksjeeierbokId;

  fullhistorikk:boolean = false;

  url(){
      return this.avhengigheter.serviceRotUrl() + "/api/aksjeeierbok/"+this.aksjeeierbokId+"/aksjeeierbok.xlsx?fullHistorikk="+this.fullhistorikk;
  }

}

@Injectable()
export class AksjeeierbokEksportDialogKomponentAvhengigheter {
    private konfigurasjon: Appkonfigurasjon;


    constructor(konfigurasjon: Appkonfigurasjon) {
        this.konfigurasjon = konfigurasjon;
    }

    serviceRotUrl(){
        return this.konfigurasjon.serviceRotUrl;
    }

}


export interface EksportDialogParametre {
    aksjeeierbokId: AksjeeierbokId
}

